import firebase from 'firebase';
import { config } from './config';

export const firebaseApp: firebase.app.App = firebase.initializeApp(config);
export const firebaseAuth: firebase.auth.Auth = firebase.auth();
export const firebaseStorage: firebase.storage.Storage = firebase.storage();
export const fireStore: firebase.firestore.Firestore = firebase.firestore();
export const functions: firebase.functions.Functions = firebase.functions();
